import React, { useContext } from 'react'

import { AppContext } from '../App'
import { authErrorAction } from '../auth'

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const { dispatch } = useContext(AppContext)
  let errorMessage = 'Something went wrong.'

  const copyToClipboard = async (text) => {
    await navigator.clipboard.writeText(text)
  }

  if (error) {
    switch (error.status) {
      case 401:
        dispatch(authErrorAction())
        break
      case 429:
        errorMessage = 'Too many requests, please try again later.'
        break
      default:
        if (error.message === 'Failed to fetch') {
          errorMessage = 'Server is offline. Please try again later.'
        } else {
          errorMessage = (
            <div>
              <h2 className='text-xl mb-10 text-red-500'>Oops, something went wrong!</h2>
              <p className='text-slate-300'>We're sorry for the inconvenience. Please contact our support team
                and provide them <br /> with the following Request ID to help us investigate the issue:
              </p>
              <div className='text-blue-400 mt-3'>
                Request ID: <span className='text-red-200'>{error.requestId}</span>
                <button
                  onClick={() => copyToClipboard(error.requestId)}
                  className='btn btn-sm ml-2'
                >
                  Copy
                </button>
              </div>
              <p className='mt-2 text-slate-300'>Thank you for your patience.</p>
            </div>
          )
        }
        break
    }
  }

  const handleRetry = () => {
    resetErrorBoundary()
  }

  return (
    <div className='container py-10 px-10 mx-0 min-w-full min-h-full flex flex-col items-center justify-center'>
      <p className='text-center'>{errorMessage}</p>
      <button className='btn btn-success mt-10' onClick={handleRetry}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
        >
          <path
            fill='currentColor'
            d='M6 19h3.692v-5.884h4.616V19H18v-9l-6-4.538L6 10zm-1 1V9.5l7-5.288L19 9.5V20h-5.692v-5.884h-2.616V20zm7-7.77'
          />
        </svg>
        Home
      </button>
    </div>
  )
}

export { ErrorFallback }
